export default "__VITE_ASSET__BTHpi46h__"